import axios from "../utils/axios.wrapper";

export const getPaymentMethods = async () => {
  const { data } = await axios.get("/paymentMethod/active");
  return data.items || data;
};

export const getPaymentMethodById = async (id) => {
  const { data } = await axios.get(`/paymentMethod/${id}`);
  return data;
};

export const createPaymentMethod = async (paymentMethod) => {
  const { data } = await axios.post("/paymentMethod/create", paymentMethod);
  return data;
};

export const updatePaymentMethod = async (id, paymentMethod) => {
  const { data } = await axios.put(`/paymentMethod/${id}`, paymentMethod);
  return data;
};

export const deletePaymentMethod = async (id) => {
  const { data } = await axios.delete(`/paymentMethod/${id}`);
  return data;
};

export const paymentMethodsService = {
  getPaymentMethods,
  getPaymentMethodById,
  createPaymentMethod,
  updatePaymentMethod,
  deletePaymentMethod,
};
